<footer class="main-footer">
  <div class="container-fluid d-flex justify-content-between small">
    <span>
      &copy; 2022. <a href="javascript:;" translate>APP_NAME</a>
      <a href="https://strikeweb.it" target="_blank">Strikeweb</a>
    </span>
    <span class="text-dark">v2.0.0</span>
  </div>
</footer>
